<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="enquete_civiliterequerant"
      v-model="sasDemandeEnquete.salutationDemandeur"
      :live="liveSasDemandeEnquete(23311)"
      order-by="text"
      optional
    ></opq-catalogue>

    <opq-text-field code="enquete_nomrequerant" v-model="sasDemandeEnquete.nomDemandeur" :live="liveSasDemandeEnquete(23310)"></opq-text-field>

    <opq-text-field code="enquete_prenomrequerant" v-model="sasDemandeEnquete.prenomDemandeur" :live="liveSasDemandeEnquete(23309)"></opq-text-field>

    <opq-text-field
      code="enquete_adresserequerant"
      v-model="sasDemandeEnquete.adresseCiviqueDemandeur"
      :live="liveSasDemandeEnquete(23312)"
      :id="'adresseCiviqueDemandeur'"
      ref="adresseCiviqueDemandeur"
    ></opq-text-field>

    <opq-text-field
      code="enquete_complementadresserequerant"
      v-model="sasDemandeEnquete.complementDAdresseDemandeur"
      :live="liveSasDemandeEnquete(23313)"
      ref="complementDAdresseDemandeur"
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_cprequerant"
      v-model="sasDemandeEnquete.codePostalDemandeur"
      :live="liveSasDemandeEnquete(23314)"
      is-code-postal
      :code-pays="codePays(sasDemandeEnquete.paysDemandeur)"
      ref="codePostalDemandeur"
    ></opq-text-field>

    <opq-text-field
      code="enquete_villerequerant"
      v-model="sasDemandeEnquete.villeDemandeur"
      :live="liveSasDemandeEnquete(23315)"
      ref="villeDemandeur"
    ></opq-text-field>

    <opq-catalogue
      code="enquete_provincerequerant"
      v-model="sasDemandeEnquete.provinceDemandeur"
      :opq-if="paysEstUSouCA(sasDemandeEnquete.paysDemandeur)"
      :live="liveSasDemandeEnquete(23316)"
      :parent="sasDemandeEnquete.paysDemandeur"
      order-by="text"
      ref="provinceDemandeur"
    ></opq-catalogue>

    <opq-catalogue
      code="enquete_paysrequerant"
      v-model="sasDemandeEnquete.paysDemandeur"
      :live="liveSasDemandeEnquete(23317)"
      ref="paysDemandeur"
      order-by="text"
    ></opq-catalogue>

    <opq-text-field
      code="enquete_telephonerequerant"
      v-model="sasDemandeEnquete.telephoneDemandeur"
      :live="liveSasDemandeEnquete(23318)"
      is-phone-number
    ></opq-text-field>

    <opq-text-field
      code="enquete_courrielrequerant"
      v-model="sasDemandeEnquete.courrielDemandeur"
      :live="liveSasDemandeEnquete(23319)"
      is-email
    ></opq-text-field>

    <opq-text-field
      code="enquete_occupationrequerant"
      v-model="sasDemandeEnquete.occupationDemandeur"
      :live="liveSasDemandeEnquete(23322)"
      optional
    ></opq-text-field>

    <opq-catalogue
      code="enquete_membreautreordrerequerant"
      v-model="sasDemandeEnquete.appartenanceOrdresProfessionnels"
      :live="liveSasDemandeEnquete(23320)"
      order-by="text"
      multiple
      optional
    ></opq-catalogue>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [FormSimple, CataloguesHelper, PosteCanada],
  props: {
    sas: { type: Object }
  },

  data: () => ({
    posteCanadaMainconfig: {
      searchFieldId: "adresseCiviqueDemandeur",
      adresseKey: "adresseCiviqueDemandeur",
      completementDAdresseKey: "complementDAdresseDemandeur",
      villeKey: "villeDemandeur",
      codePostalKey: "codePostalDemandeur",
      provinceKey: "provinceDemandeur",
      paysKey: "paysDemandeur"
    }
  }),

  computed: {
    sasDemandeEnquete() {
      return this.sas.sasDemandeEnquete
    }
  },

  methods: {
    liveSasDemandeEnquete(cle) {
      return { endpoint: "/sas-demande-enquete/", cle: cle, fileId: this.sasDemandeEnquete.id }
    }
  }
}
</script>

<style>
</style>